import { WidgetProps } from '@rjsf/utils';
import { Box, Typography } from '@mui/material';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Colors } from '../../../../ui/theme/colors';
import { useLoginTabStyles } from '../../../couriers/components/courier-form.styles';

/** A segmented control over a schema's `oneOf` options, styled as the courier form's login tabs. */
export function DynamicFormToggleGroup(props: WidgetProps) {
  const classes = useLoginTabStyles();
  const options = (props.options.enumOptions ?? []) as { label: string; value: string }[];
  const disabled = props.disabled || props.readonly;

  return (
    <Box>
      <Typography variant="caption" style={{ color: Colors.midGray }}>
        {props.label}
      </Typography>
      <Box
        sx={{
          marginTop: 0.5
        }}
      >
        <ToggleButtonGroup
          id={props.id}
          value={props.value ?? null}
          exclusive
          onChange={(_event, value: string | null) => value && props.onChange(value)}
        >
          {options.map((option) => (
            <ToggleButton
              key={option.value}
              value={option.value}
              disabled={disabled}
              classes={{ selected: classes.selected }}
            >
              {option.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
}
